import axios from 'axios';
import { push } from 'connected-react-router';
import TagManager from 'react-gtm-module';
import { AnyAction } from 'redux';
import { call, put } from 'redux-saga/effects';
import { RESET_STATE, showError } from './Commons';

export const SET_EMIT_FORM = 'EMIT_FORM/SET';
export const SUBMIT_EMIT_FORM = 'PROPOSAL/SUBMIT';
export const EMITTING = 'EMITTING';
export const FAIL_EMITTING = 'EMITTING/FAIL';
export const SET_PROPOSAL = 'PROPOSAL/SET';
export const URL_EMIT = '/closure';

export type PaymentMethod = 'CMR' | 'OTHERS';

export interface IPaymentForm {
  paymentMethod: PaymentMethod;
  cmrCard: string;
}

export interface IEmitForm {
  charges: string;
  cmrCard?: string;
  paymentMethod: PaymentMethod;
  beneficiary1: string;
  beneficiary2: string;
  beneficiary3: string;
  beneficiary4: string;
  beneficiary5: string;
  beneficiary6: string;
  personalDataPolicy: string;
  commercialPurposes: string;
}

export interface IProposal {
  errorMessage: string;
  number: number;
}

export const submitEmitForm = (payload: IEmitForm) => ({
  payload,
  type: SUBMIT_EMIT_FORM,
});

export const emitting = () => ({
  type: EMITTING,
});

export const failEmitting = () => ({
  type: FAIL_EMITTING,
});

export const setEmitForm = (payload: IEmitForm) => ({
  payload,
  type: SET_EMIT_FORM,
});

export const setProposal = (payload: IProposal) => ({
  payload,
  type: SET_PROPOSAL,
});

const initialState = {
  data: {
    cmrCard: '',
    paymentMethod: 'CMR',
  },
  emitting: false,
  proposal: {
    errorMessage: '',
    number: 0,
  },
};

export default function proposal(state = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_EMIT_FORM:
      return {
        ...state,
        data: action.payload,
      };
    case EMITTING:
      return {
        ...state,
        emitting: true,
      };
    case FAIL_EMITTING:
      return {
        ...state,
        emitting: false,
      };
    case SET_PROPOSAL:
      return {
        ...state,
        emitting: false,
        proposal: action.payload,
      };
    case RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function* doEmit({ payload }: AnyAction) {
  try {
    yield put(emitting());
    yield put(setEmitForm(payload));

    const {
      address,
      addressNumber,
      birthdate,
      city,
      colony,
      cmrCard,
      documentId,
      firstName,
      middleName,
      lastName,
      genre,
      mail,
      phone,
      state,
      town,
      zipcode,
     } = payload;

    const emissionData = {
      address1: address,
      address2: addressNumber.toString(),
      address3: colony,
      address4: town,
      birthdate: birthdate.replace(/-/g,'/'),
      city,
      cmrCard,
      companyCheck: 'Seleccionado',
      consentCheck: 'Seleccionado',
      email: mail,
      insuredFirstName: firstName,
      insuredFormalName: `${firstName} ${middleName ? middleName : ''} ${lastName}`,
      insuredLastName: lastName,
      insuredMiddleName: middleName ? middleName : '',
      legalTermsCheck: 'Seleccionado',
      phone: `+52${phone}`,
      postalCode: zipcode.toString(),
      province: state,
      reference1: documentId,
      sexCode: genre,
    };

    const leadUrl = `${process.env.REACT_APP_STORELEAD_API_URL}`;

    const { data } = yield call(axios.post, leadUrl, emissionData);

    yield put(push('/success'));
    yield put(setProposal(data));
  } catch (error) {
    yield put(failEmitting());
    yield put(showError());
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvError',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);
    }
  }
}
